import React, { useState } from 'react'
import UIButton from '../../components/UI/UIButton'

import { Icon } from '../../components/Icon'
import { ReactComponent as LogoSvg } from '../../assets/svgs/logos/Logo.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import { setupPasswordVerification } from '../../api/auth/password'
import { getSinglePolicy } from '../../utils/types'
import { toast } from 'react-toastify'

function PasswordVerification() {
  const location = useLocation()

  const [isLoading, setIsLoading] = useState(false)
  const searchParams = new URLSearchParams(location.search)
  const uid = searchParams.get('uid')
  const verificationToken = searchParams.get('verification-token')

  const navigate = useNavigate()

  const setupVerification = async (): Promise<void> => {
    setIsLoading(true)
    const response = (await setupPasswordVerification(
      {
        token: verificationToken,
      },
      uid
    )) as {
      status?: string
      data: getSinglePolicy
    }
    if (response?.status == 'successful') {
      toast.success('verified, now login with credentials', {
        position: 'top-right',
      })
      navigate('/')
      setIsLoading(false)
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
      setIsLoading(false)
    }
  }
  return (
    <div className="min-h-screen bg-gray1 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="mx-5 sm:mx-auto sm:w-full sm:max-w-lg flex">
        <div className="flex gap-4 flex-1 ">
          <LogoSvg width={130} height={36} />
        </div>
      </div>

      <div className="mx-5 sm:mx-auto mt-8 sm:w-full sm:max-w-lg">
        <div className="bg-white py-10 px-4 shadow rounded-[1rem] sm:px-10">
          <div className="flex flex-col py-2 gap-3 justify-center items-center text-center mt-7">
            <Icon
              name="IconPasscodeLock"
              width={52}
              height={52}
              strokeWidth={1}
              stroke={'#02698C'}
            />
            <p className="text-[14px] font-medium text-text2">
              Please click the below link to verify your email address.{' '}
            </p>
          </div>
          <div className="mt-8">
            <div className="container mx-auto mt-8">
              <UIButton
                onClick={setupVerification}
                label="Verify"
                loading={isLoading}
              />
            </div>
          </div>
        </div>

        <div className="sm:mx-auto w-full h-auto px-8 my-4 py-6 rounded-[1rem] gap-16 bg-gray2">
          <div className="flex gap-3 items-center">
            <Icon
              name={'IconCheckMonogram'}
              width={16}
              height={16}
              strokeWidth={1}
            />
            <div
              className="cursor-pointer"
              onClick={() => navigate('/privacy-policy')}
            >
              <p className="font-medium text-xs text-text1">Privacy Policy</p>
            </div>
            <div
              className="cursor-pointer"
              onClick={() => navigate('/terms-condiditions')}
            >
              <p className="font-medium text-xs text-text1">
                Terms & Conditions
              </p>
            </div>
          </div>
          <div className="mt-4">
            <p className="font-medium text-xs text-text3">
              © 2025 Streamlearn Ltd. All rights reserved. 360 Safeguarding is
              a trading name of Streamlearn Ltd. Company No. 12180453.
              Registered office: Axis 19 Mallard Way, Riverside Business Park,
              Swansea Vale, Swansea, SA7 0AJ.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PasswordVerification
